import { FeatureFlag, ResolverTag } from '@ps/web-core-enums';
import { useFeature } from '@ps/web-core-store';
import { useResolver } from '@ps/web-shared-components';

import { BroadcastChannelCommunication } from '../communication/broadcast-channel';
import { type Message, OpenTableAction } from '../types/types';
import { ACTIVE_TABLE_CHANNEL_NAME, isBroadcastChannelAvailable } from '../utils/utils';

let communication: BroadcastChannelCommunication | null = null;
if (isBroadcastChannelAvailable()) {
  communication = new BroadcastChannelCommunication({
    name: ACTIVE_TABLE_CHANNEL_NAME
  });
}

const useOpenActiveTable = () => {
  const resolver = useResolver(ResolverTag.WebPoker);
  const activeTableDebugEnabled = useFeature(FeatureFlag.PKRNavigationActiveTableDebug);

  const openActiveTable = (message: Message) => {
    if (!communication) return;

    const url = new URL(resolver);
    url.searchParams.set('standalonetable', 'true');
    if (activeTableDebugEnabled) {
      url.searchParams.set('debug', 'true');
    }
    const resolverWithArgs = url.toString();
    const openTabActionResult = communication.openTableWindow(resolverWithArgs, message);
    if (openTabActionResult.action === OpenTableAction.ALREADY_ACTIVE) {
      // Show a message to the user that the table is already open
    }

    return openTabActionResult;
  };

  return {
    openActiveTable
  };
};

export default useOpenActiveTable;
